import React from 'react';
import { Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import Loader from 'react-loader';
import AuthService from '@services/AuthService';

class ForceChangePassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            newPassword: '',
            newPasswordConfirm: '',
            loaded: true
        }

        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    onChange(e) {
        const trg = e.target;
        this.setState(state => {
            state[trg.name] = trg.value;
            return state;
        });
    }

    onSave() {
        if (!this.validate()) return;

        this.setState({ loaded: false });

        const data = {
            old_password: this.state.password,
            password: this.state.newPassword
        }

        AuthService.saveNewPassword(data).then(resp => {
            if (!resp.data.success) {
                toast.error(resp.data.message);
                this.setState({ loaded: true });
            }
            else {
                toast.success(resp.data.message);
                this.setState({ loaded: true }, () => {
                    setTimeout(() => this.props.onPasswordChange(), 2500);
                });
            }
        })
    }

    validate() {
        const re = /(?=.*?[0-9])(?=.*?[A-Z])(?=.*?[a-z])/;

        if (!this.state.password.length) {
            toast.error('Current password cannot be empty');
            return false;
        }
        if (this.state.newPassword !== this.state.newPasswordConfirm) {
            toast.error('Fields New Password and Confirm New Password don\'t match');
            return false;
        }
        if (!re.test(this.state.newPassword)) {
            toast.error('New password must contain a capital, lowercase, and number');
            return false;
        }
        return true;
    }

    render() {
        return (
            <div className="row">
                <div className="col-1"></div>
                <div className="col-4">
                    <div
                        className="login-block"
                        style={{
                            padding: '40px',
                            border: '1px solid #7C858C',
                            marginTop: '40px',
                            backgroundColor: 'white'
                        }}>
                        <div className="row">
                            <div className="col">
                                <label className="font-weight-bold">Current Password</label>
                                <input
                                    type="password"
                                    autoComplete="off"
                                    name="password"
                                    className="form-control"
                                    onChange={this.onChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col"><hr /></div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                <strong>New password:</strong>
                                <ul>
                                    <li>must be at least 8 characters</li>
                                    <li>must contain a capital, lowercase, and number</li>
                                </ul>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col">
                                <label className="font-weight-bold">New Password</label>
                                <input
                                    type="password"
                                    autoComplete="off"
                                    name="newPassword"
                                    className="form-control"
                                    onChange={this.onChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label className="font-weight-bold">Confirm New Password</label>
                                <input
                                    type="password"
                                    autoComplete="off"
                                    name="newPasswordConfirm"
                                    className="form-control"
                                    onChange={this.onChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col"><hr /></div>
                        </div>
                        <div className="row">
                            <div className="col text-right">
                                <Loader loaded={this.state.loaded} left="calc(100% - 50px)" top="15px" scale={0.5}>
                                    <button type="button" className="btn btn-primary-new" onClick={this.onSave}>Save</button>
                                </Loader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ForceChangePassword;


// WEBPACK FOOTER //
// ./src/views/Pages/Login/ForceChangePassword/ForceChangePassword.js